import Flipclock from './Flipclock'

export default Flipclock
